



























import {Component, Emit, Prop, Provide, Vue} from 'vue-property-decorator'
import {Contract} from '@/model/resource/Contract'
import {InputContractSchema} from '@/schema/resource/Contract/InputContractSchema'
import {Dapp} from '@/model/resource/Dapp'

@Component
export default class PersistContractView extends Vue {
  @Prop() id?: string
  @Prop() dapp!: Dapp

  @Provide('validator') validator = this.$validator

  schema = new InputContractSchema()
  contract = new Contract()

  async created() {
    this.contract.dapp = this.dapp
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.contract.getContract(id)
    }

    this.$await.done('getContract')
  }

  @Emit('persist')
  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }
    return this.contract
  }
}
